import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {Modal} from "react-bootstrap";
import axios from "axios";
import {ITEM_COUNT_PER_PAGE, RESOURCE_BASE_URL} from "../../../../configuration";
import ViewReplies from "./ViewReplies";
import "./ViewInquiry.css";
import noRecords from '../../../../assets/img/norecord.png';
import ShowMoreText from 'react-show-more-text';
import FormFieldValidationError from "../../../Common/FormFieldValidationError/FormFieldValidationError";
import InitialQuotationState from "../../QuotationForm/InitialQuotationState";
import GoogleAds from "../../../Common/GoogleAds/GoogleAds";

class ViewInquiry extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            email: this.props.inquiryData.email,
            subject: this.props.inquiryData.subject,
            inquiry: this.props.inquiryData.message,
            createdOn: this.props.inquiryData.createdDate,
            replies: this.props.inquiryData.inquiryReplies,
            repliedByAdminName: "",
            repliedAdminId: "",
            reply: "",
            lastReplyId: "",
            replyError: "",
            showError: false,
            showsuccess: false

        };

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

    }

    validateReply = () => {
        let reply = this.state.reply;
        return (reply !== "");
    };

    onInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
            replyError: ""
        });
    };

    onSubmit = (event) => {
        event.preventDefault();
        let replyError = "";
        let validationPassed = true;

        if (!this.validateReply(event)) {
            validationPassed = false;
            replyError = "app.validation.inquiry-reply.invalid-reply";
        }

        if (validationPassed) {
            // console.log("Validation passed");
            this.saveReply();
        } else {

            this.setState({replyError});
        }
    };

    saveReply = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        let resourceUrl = RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryData.id + '/reply';
        // console.log(resourceUrl, this.state.reply, this.props.inquiryData.userId);
        axios.post(resourceUrl
            , {
                reply: this.state.reply,
                repliedByAdminId: localStorage.getItem("userId"),
                // repliedByAdminId: this.props.inquiryData.userId,
                //inquiryId: this.props.inquiryData.id,
                isFromAdmin: 0
            }, axiosConfig)
            .then((res) => {
                // this.changeStatusToNew();
                // console.log("New reply saved", res);
                this.setState({showSuccess: true});

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                this.setState({showError: true});
            });

    };

    changeStatusToNew = () => {
        let newStat = 'NEW';
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };
        axios.get(RESOURCE_BASE_URL + 'api/users/inquiries/statusChange/' + this.props.inquiry.id + '/' + newStat)
            .then((res) => {

                // console.log("changed status",res.data);
            })
            .catch((err) => {

                console.log("[API] ERROR:with status ", err);
            });

    };

    handleCloseError = () => {
        this.setState({
            showError: false,
        })
    };

    handleCloseSuccess = () => {
        this.setState({
            showSuccess: false,
            show: false,
            reply: ''
        }, () => this.props.getUserInquiries(0, 5));
        // this.props.getUserInquiries(0,5);
    };

    handleClose = () => {
        let putData = {
            replyId: this.state.lastReplyId

        };
        // console.log("replyid",this.state.lastReplyId);

        let config = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*'
            }
        };

        axios.put(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryData.id + '/reply/edit/status/' + this.state.lastReplyId, config)
            .then((res) => {
                // console.log(res.data);
                // console.log("status updated successfully");
                this.props.getUserInquiries(0, 5);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

        this.setState({
            show: false,
            reply: ""
        });

    };

    handleShow = () => {
        this.setState({
            show: true,
        });

    };

    getReply() {
        axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryData.id + '/viewReply')
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    replies: res.data.inquiryReplies

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    getLastReplyId() {
        axios.get(RESOURCE_BASE_URL + 'api/inquiries/' + this.props.inquiryData.id + '/reply/last/id')
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    lastReplyId: res.data

                });
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
    }

    componentDidMount() {
        // this.getReply();
        // this.getLastReplyId();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({replies: this.props.inquiryData.inquiryReplies});
        }
    }

    render() {
        return (
            <span>
                <GoogleAds slot="696274611"/>
                <div className="custom-col-12">
                    <a className="btn btn-xs btn-success unify-btn-responsive-user-profile view-qc-btn-resp" onClick={this.handleShow}>
                        <FormattedMessage id="app.admin-inquiry-row.view"
                                          defaultMessage="View"
                                          description=""/>

                    </a>
                </div>
                <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="view-inquiry-modal inq-modal">
                    {/*<form onSubmit={this.onSubmit}>*/}
                    <Modal.Header closeButton>
                            <div className="title-1 color-text ">
                                <FormattedMessage id="app.admin-inquiry-view.title"
                                                  defaultMessage="View Inquiry"
                                                  description=""/>

                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <br/>
                             <div className="row line-height-inq-site">
                                 <div className="">
                                     <div className="col-md-2">
                                       <b> 日時</b>
                                    </div>
                                    <div className="col-md-8">
                                        {this.state.createdOn.substring(0, 4)} 年 {this.state.createdOn.substring(5, 7)} 月
                                        {this.state.createdOn.substring(8, 10)} 日&nbsp;&nbsp;{this.state.createdOn.substring(11, 16)}
                                    </div>
                                    </div>
                            </div>


                             <div className="row line-height-inq-site">
                                 <div className="">
                                     <div className="col-md-2">
                                       <b><FormattedMessage id="app.admin-inquiry-view.email"
                                                         defaultMessage="Email"
                                                            description=""/></b>
                                    </div>
                                    <div className="col-md-8 ">
                                        {/*<input type="text"
                                               className="form-control input-sm"
                                               name="subject"
                                               disabled={true}
                                               value={this.state.email}
                                        />*/}
                                        {this.state.email}
                                    </div>
                                    </div>
                            </div>
                            <div className="row line-height-inq-site">
                                 <div className="">
                                     <div className="col-md-2">
                                       <b>件名</b>
                                    </div>
                                    <div className="col-md-8 ">
                                        {/*<input type="text"
                                               className="form-control input-sm"
                                               name="subject"
                                               disabled={true}
                                               value={this.state.subject}
                                        />*/}

                                        <span>
                            {this.state.subject === 'QUOTATION_RELATED' ?
                                <text>お見積りに関するご質問</text> :
                                this.state.subject === 'PRODUCTION_RELATED' ?
                                    <text>製造基準・技術的に関するご質問</text> :
                                    this.state.subject === 'PRICING_RELATED' ?
                                        <text>ご注文やサービスご利用に関するご質問</text> :
                                        this.state.subject === 'PAYMENT_RELATED' ?
                                            <text>お支払いに関するご質問</text> :
                                            this.state.subject === 'QUALITY_RELATED' ?
                                                <text>出荷に関するご質問</text> :
                                                this.state.subject === 'REQUEST' ? <text>無料基板サンプル請求</text> : <text>その他</text>
                            }
                        </span>
                                    </div>
                                    </div>
                            </div>
                        <div className="row line-height-inq-site">
                            <div className="">
                                <div className="col-md-2">
                                    <b>内容</b>
                                </div>
                                <div className="col-md-7">

                                    <ShowMoreText
                                        lines={2}
                                        more='...詳細'
                                        less='...閉じる'
                                        anchorClass=''
                                    >
                                    {this.state.inquiry}
                                    </ShowMoreText>
                                </div>
                            </div>
                        </div>
                            <hr/>
                            <div className=" ">
                            <div className=" ">
                                <FormattedMessage id="app.inquiry-view.replies"
                                                  defaultMessage="Replies"
                                                  description=""/>
                            </div><br/>
                        </div>
                            <div className="row"></div>
                            {this.state.replies.length === 0 &&

                            <div className="">
                                <div className="spacer"></div>
                                {/*<img className="no-reply-img" alt=""
                                         src={noRecords}/>*/}
                                <h5 id="no-reply-txt">このお問い合わせに関しまして管理チームの方で対応中です。しばらくお待ちください。</h5>
                                {/*<h4>no replies to show at the moment .Our admin team will reply you as soon as possible !</h4>*/}
                            </div>

                            }
                            {/*{console.log("reptest",this.state.replies)}*/}
                            {/*{console.log("inqdata",this.props.inquiryData)}*/}

                            {this.state.replies.map(replyData => {
                                return <ViewReplies replyData={replyData} inquiry={this.props.inquiryData}
                                                    getUserInquiries={this.props.getUserInquiries}/>;

                            })}
                            <br/>
                            <div className="">
                            <div className=" ">
                                <div className="">
                                     <FormattedMessage id="app.inquiry-reply.reply"
                                                       defaultMessage="Reply"
                                                       description=""/>
                                            <span className="mandatory-star"> *</span>
                                    <textarea type="text"
                                              className="inq-textarea"
                                              name="reply"
                                              value={this.state.reply}
                                              onChange={this.onInputChange}
                                              rows={5}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="qc-reply-error-resp">
                                <FormFieldValidationError errors={this.state.replyError}/>
                            </div>
                        </div>
                            <div className="text-right-align">
                                <a className="btn btn-success btn-inq-site" onClick={this.onSubmit}>
                                   返信
                                </a>
                                <a className="btn btn-default btn-inq-site" onClick={this.handleClose}>
                                   <FormattedMessage id="app.inquiry-view.replies.close"
                                                     defaultMessage="Close"
                                                     description=""/>
                                </a>
                            </div>

                            <br/>

                        </Modal.Body>

                    {/*</form>*/}
                </Modal>
                <Modal dialogClassName="message-modal" show={this.state.showSuccess} onHide={this.handleCloseSuccess}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-success"
                                              defaultMessage="Success"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-8 data-label">

                                    <FormattedMessage id="app.inquiry-reply.inquiry-sent"
                                                      defaultMessage="Reply sent successfully"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleCloseSuccess}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal dialogClassName="message-modal" show={this.state.showError} onHide={this.handleCloseError}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-reply.inquiry-error"
                                              defaultMessage="Error"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-offset-1 data-label">

                                    <FormattedMessage id="app.inquiry-reply.inquiry-not-sent"
                                                      defaultMessage="Error occurred while sending the reply mail to user"
                                                      description=""/>

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-2 pull-right" onClick={this.handleCloseError}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        )
    }

}

export default ViewInquiry;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/VIewInquiry/ViewInquiry.js